// icon-features.js
document.addEventListener('DOMContentLoaded', () => {
  // CSS hovers handle the border change and zoom effects.
});
